import { Input, Select } from "antd";
import React, { useState } from "react";

const { Option } = Select;

function LmsCountryCode(props) {
    const [contact_number, set_contact_number] = useState(
        props.contact || ""
    );

    const [country, setCountry] = useState(props.country || "IN");

    const countries = [
        "AW", "AF", "AO", "AI", "AX", "AL", "AD", "AE", "AR", "AM", "AQ", "AG",
        "AU", "AT", "AZ", "BI", "BE", "BJ", "BF", "BD", "BG", "BH", "BS", "BA",
        "BY", "BZ", "BM", "BO", "BR", "BB", "BN", "BT", "BV", "BW", "CF", "CA",
        "CC", "CH", "CL", "CN", "CI", "CM", "CD", "CG", "CK", "CO", "KM", "CV",
        "CR", "CU", "CW", "CX", "KY", "CY", "CZ", "DE", "DJ", "DM", "DK", "DO",
        "DZ", "EC", "EG", "ER", "EH", "ES", "EE", "ET", "FI", "FJ", "FK", "FR",
        "FO", "FM", "GA", "GB", "GE", "GG", "GH", "GI", "GN", "GP", "GM", "GW",
        "GQ", "GR", "GD", "GL", "GT", "GF", "GU", "GY", "HK", "HM", "HN", "HR",
        "HT", "HU", "ID", "IM", "IN", "IO", "IE", "IR", "IQ", "IS", "IL", "IT",
        "JM", "JE", "JO", "JP", "KZ", "KE", "KG", "KH", "KI", "KN", "KR", "XK",
        "KW", "LA", "LB", "LR", "LY", "LC", "LI", "LK", "LS", "LT", "LU", "LV",
        "MO", "MF", "MA", "MC", "MD", "MG", "MV", "MX", "MH", "MK", "ML", "MT",
        "MM", "ME", "MN", "MP", "MZ", "MR", "MS", "MQ", "MU", "MW", "MY", "NA",
        "NC", "NE", "NF", "NG", "NI", "NU", "NL", "NO", "NP", "NR", "NZ", "OM",
        "PK", "PA", "PN", "PE", "PH", "PW", "PG", "PL", "PR", "PT", "PY", "PS",
        "QA", "RE", "RO", "RU", "RW", "SA", "SD", "SN", "SG", "GS", "SH", "SJ",
        "SB", "SL", "SV", "SM", "SO", "PM", "RS", "SS", "ST", "SR", "SK", "SI",
        "SE", "SZ", "SX", "SC", "SY", "TC", "TD", "TG", "TH", "TJ", "TK", "TM",
        "TL", "TO", "TT", "TN", "TR", "TV", "TW", "TZ", "UG", "UA", "UM", "UY",
        "US", "UZ", "VA", "VC", "VE", "VN", "VG", "VI", "VU", "WF", "WS", "YE",
        "ZA", "ZM", "ZW"
    ];

    const getFlagUrl = (code) =>
        `https://flagcdn.com/w40/${code.toLowerCase()}.png`;

    const handleCountryChange = (value) => {
        setCountry(value);

        if (props.set_country_code) {
            props.set_country_code(value);
        }
    };

    const handleContactChange = (e) => {
        const value = e.target.value.replace(/\D/g, "");

        set_contact_number(value);

        if (props.set_contact_no) {
            props.set_contact_no(value);
        }
    };

    const selectBefore = (
        <Select
            value={country}
            onChange={handleCountryChange}
            popupClassName="lms-country-dropdown"
            className="lms-country-select"
            showSearch
            optionFilterProp="value"
            dropdownMatchSelectWidth={50}
        >
            {countries.map((code) => (
                <Option key={code} value={code}>
                    <div className="lms-country-option">
                        <img
                            src={getFlagUrl(code)}
                            alt={code}
                            className="lms-country-flag"
                        />
                        <span>{code}</span>
                    </div>
                </Option>
            ))}
        </Select>
    );

    return (
        <div className="lms-country-code-wrap">
            <style>{`
                .lms-country-code-wrap {
                    width: 100%;
                }

                /* Main input wrapper */
                .lms-country-code-wrap
                .ant-input-group-wrapper {
                    width: 100%;
                }

                .lms-country-code-wrap
                .ant-input-wrapper {
                    display: flex !important;
                    width: 100%;
                }

                /* Country selector */
                .lms-country-code-wrap
                .ant-input-group-addon {
                    width: 112px !important;
                    min-width: 112px !important;
                    padding: 0 !important;
                    background: #07070c !important;
                    border: 1px solid #3d414f !important;
                    border-right: 0 !important;
                    border-radius: 7px 0 0 7px !important;
                    overflow: hidden;
                }

                .lms-country-code-wrap
                .lms-country-select {
                    width: 100% !important;
                    height: 45px !important;
                }

                .lms-country-code-wrap
                .lms-country-select
                .ant-select-selector {
                    height: 45px !important;
                    width: 100% !important;
                    padding: 0 12px !important;
                    background: #07070c !important;
                    border: none !important;
                    border-radius: 0 !important;
                    box-shadow: none !important;
                    display: flex !important;
                    align-items: center !important;
                }

                .lms-country-code-wrap
                .lms-country-select
                .ant-select-selection-item {
                    color: #fff !important;
                    line-height: 35px !important;
                    padding-right: 18px !important;
                }

                .lms-country-code-wrap
                .lms-country-select
                .ant-select-arrow {
                    color: #97b8ff !important;
                }

                /* Contact input */
                .lms-country-code-wrap .ant-input {
                    height: 45px !important;
                    background: #07070c !important;
                    border: 1px solid #3d414f !important;
                    border-left: 1px solid #3d414f !important;
                    border-radius: 0 7px 7px 0 !important;
                    color: #fff !important;
                    font-size: 16px;
                    box-shadow: none !important;
                }

                .lms-country-code-wrap
                .ant-input::placeholder {
                    color: rgba(255, 255, 255, 0.30) !important;
                }

                /* Focus */
                .lms-country-code-wrap
                .ant-input-group-wrapper:focus-within
                .ant-input-group-addon {
                    border-color: #16fcfb !important;
                }

                .lms-country-code-wrap
                .ant-input:focus {
                    border-color: #16fcfb !important;
                    box-shadow: none !important;
                }

                .lms-country-code-wrap
                .ant-input-group-wrapper:focus-within
                .ant-input {
                    border-color: #16fcfb !important;
                }

                /* Country option */
                .lms-country-option {
                    display: flex;
                    align-items: center;
                    gap: 9px;
                    height: 32px;
                    color: #fff;
                }

                .lms-country-flag {
                    width: 24px;
                    height: 16px;
                    object-fit: cover;
                    display: block;
                    flex-shrink: 0;
                }

                /* Dropdown */
                .lms-country-dropdown {
                    background: #0a0a12 !important;
                    border: 1px solid #3d414f !important;
                    padding: 4px !important;
                }

                .lms-country-dropdown
                .ant-select-item {
                    color: #fff !important;
                    background: transparent !important;
                    border-radius: 5px !important;
                    padding: 5px 10px !important;
                }

                .lms-country-dropdown
                .ant-select-item-option-selected {
                    background: rgba(22, 252, 251, 0.15) !important;
                    color: #16fcfb !important;
                }

                .lms-country-dropdown
                .ant-select-item-option-active {
                    background: rgba(151, 184, 255, 0.15) !important;
                }

                /* Responsive */
                @media (max-width: 576px) {
                    .lms-country-code-wrap
                    .ant-input-group-addon {
                        width: 100px !important;
                        min-width: 100px !important;
                    }
                }
            `}</style>

            <Input
                addonBefore={selectBefore}
                placeholder="Contact No"
                value={contact_number}
                onChange={handleContactChange}
                inputMode="numeric"
                maxLength={10}
            />
        </div>
    );
}

export default LmsCountryCode;